import React from 'react';
import '../template-file-css/document-file-template.css';


export const LCS_ProgressSummary2023 = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='LCS_ProgressSummary2023' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    <h3>Progress Summary </h3>
                    <h4>Clinical Update </h4>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Review Period:</span>
                    <input type="date" id="txtReviewPeriod" name="txtReviewPeriod" className='add-only w-250 custom-add-only' />
                    &nbsp;
                    to
                    &nbsp;
                    <input type="date" id="txtReviewPeriod1" name="txtReviewPeriod1" className='add-only w-250 custom-add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Has client been hospitalized during this time period?</span>

                            <input type="radio" id="rbClientTime_Yes" name="rbClientTime" className='add-only' value="Yes" /> Yes &nbsp;

                            <input type="radio" id="rbClientTime_No" name="rbClientTime" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Has client had any changes in their behavior or home situation?</span>

                            <input type="radio" id="rbClientHome_Yes" name="rbClientHome" className='add-only' value="Yes" /> Yes &nbsp;

                            <input type="radio" id="rbClientHome_No" name="rbClientHome" className='add-only' value="No" /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Has there been any deviations from the treatment plan?</span>

                            <input type="radio" id="rbDeviationPlan_Yes" name="rbDeviationPlan" className='add-only' value="Yes" /> Yes &nbsp;

                            <input type="radio" id="rbDeviationPlan_No" name="rbDeviationPlan" className='add-only' value="No" /> No
                        </td>
                    </tr> 
                </table>
                <p className='w-750'>
                            <textarea id="txtDeviationPlan" name="txtDeviationPlan" className='add-only' placeholder="If yes, please explain"></textarea>

                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Delivery of all services identified on the treatment plan</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="cbDelivery_Psy" id="cbDelivery_Psy" className='add-only' value="Psychotherapy" />
                            Psychotherapy
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbDelivery_Fft" id="cbDelivery_Fft" className='add-only' value="FFT" />
                            FFT
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbDelivery_Mst" id="cbDelivery_Mst" className='add-only' value="MST" />
                            MST
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="cbDelivery_Cpst" id="cbDelivery_Cpst" className='add-only' value="CPST" />
                            CPST
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbDelivery_Psr" id="cbDelivery_Psr" className='add-only' value="PSR" />
                            PSR
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="cbDelivery_Crisis" id="cbDelivery_Crisis" className='add-only' value="Crisis" />
                            Crisis
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="cbDelivery_Med" id="cbDelivery_Med" className='add-only' value="Med Mgmt" />
                            Med Mgmt
                        </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>
                <p className='w-750'>
                            <span className='eleHeader'>Progress in services? :</span>
                            <select id="ddlProgressServices" name="ddlProgressServices" className='add-only'>
                                <option value="select">&nbsp;</option>
                                <option value="0">0 - Regressed/Gotten Worse</option>
                                <option value="1">1 - No Progress/Not at all</option>
                                <option value="2">2 - Minor Progress</option>
                                <option value="3">3 - Partial/Moderate Progress</option>
                                <option value="4">4 - Significant Progress</option>
                                <option value="5">5 - Completely/Goal Accomplished</option>
                            </select>

                </p> 
                <p className='w-750'> 
                            <span className='eleHeader'>Narrative Summary:</span>
                            <span className='small'>(A summary of activities and actions taken, by whom, and progress towards treatment goals)</span>
                            <textarea id="txtNarrativeSummary" name="txtNarrativeSummary" className='add-only'></textarea>
                </p>
                <p className='w-750'> 
                            <span className='eleHeader'>Next Progress Review Date:</span>
                            <input type="date" id="txtReviewDate" name="txtReviewDate" className='add-only' />
                </p> 
                <table>
                    <tr>
                        <td className='w-600 signature'>&nbsp; </td>
                        <td className='w-150 signature'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='w-600 small'>Consumer Signature
                        </td>
                        <td className='w-150 small'>Date
                        </td>
                    </tr>
                    <tr>
                        <td className='w-600 signature'>&nbsp;
                        </td>
                        <td className='w-150 signature'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-600 small'>Parent/Legal Guardian
                        </td>
                        <td className='w-150 small'>Date
                        </td>
                    </tr>

                    <tr>
                        <td className='w-600 signature'>&nbsp;
                        </td>
                        <td className='w-150 signature'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-600 small'>Staff Members/Witness
                        </td>
                        <td className='w-150 small'>Date
                        </td>
                    </tr>
                </table>
            </div>
        </form>

    )
} 